require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-carl-cox-anxiety-gender-equality-drug-policy.json") })
        }
      }, "path---interview-carl-cox-anxiety-gender-equality-drug-policy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-carl-cox-anxiety-gender-equality-drug-policy!./.cache/json/interview-carl-cox-anxiety-gender-equality-drug-policy.json
// module id = 659
// module chunks = 231608221292675